import { KindOfResearch } from '@/api/enums';
import { formatMinutes, formatMinutesRange } from '@/utils/date';
import { interviewDurationRange } from '@common/utils';

/**
 * Participant-facing study length. AI-moderated interviews render as a
 * "low–high" range; every other kind renders the single stored number.
 */
export function formatStudyLength(
  minutes: number,
  kindOfResearch: number | null | undefined,
): string {
  if (kindOfResearch === KindOfResearch.AI_MODERATED_INTERVIEW) {
    const { low, high } = interviewDurationRange(minutes);
    return formatMinutesRange(low, high);
  }
  return formatMinutes(minutes);
}
